"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const lucide_1 = require("lucide");
const control_1 = require("@/ui/form/control");
require("./select.less");
const defaultOptions = {
    selections: [],
    placeholder: "",
    defaultValue: "",
    width: 200,
};
class Select extends control_1.FormControl {
    constructor(target, _options) {
        super(((0, jsx_runtime_1.jsxs)("div", { className: "select", children: [(0, jsx_runtime_1.jsxs)("button", { className: "select-button", children: [(0, jsx_runtime_1.jsx)("span", { className: "select-button-label" }), (0, jsx_runtime_1.jsx)("div", { className: "icon-wrapper", children: (0, lucide_1.createElement)(lucide_1.ChevronDown) })] }), (0, jsx_runtime_1.jsx)("div", { className: "select-list", children: _options.selections.map(({ value, text }, index) => ((0, jsx_runtime_1.jsx)("div", { className: "select-list-item", "data-value": value, children: (0, jsx_runtime_1.jsx)("button", { onClick: () => {
                                this.select(value);
                                this.closeList();
                            }, children: text }) }, index))) })] })), target, defaultOptions, _options);
        this._value = null;
        this._isOpened = false;
        this._selectButton = this._element.querySelector(".select-button");
        this._selectButtonLabel = this._selectButton.querySelector(".select-button-label");
        this._selectListElem = this._element.querySelector(".select-list");
        if (this._options.selections.length === 0)
            throw new Error("Cannot create an empty select component.");
        this.selections = this._options.selections;
        if (this._options.placeholder)
            this._selectButtonLabel.textContent = this._options.placeholder;
        if (this._options.defaultValue) {
            this.select(this._options.defaultValue);
        }
        else if (!this._options.placeholder) {
            this.select(this.selections[0].value);
        }
        if (this._options.disabled)
            this.disabled = this._options.disabled;
        if (this._options.width)
            this._element.style.width = this._selectButton.style.width = `${this._options.width}px`;
        if (this._options.height)
            this._element.style.height = this._selectButton.style.height = `${this._options.height}px`;
        this._selectButton.addEventListener("click", () => {
            this._isOpened
                ? this.closeList()
                : this.openList();
        });
        // Remove the selection menu when the user clicks outside
        document.body.addEventListener("mousedown", (e) => {
            if (!e.target.closest(".select")) {
                this.closeList();
            }
        });
        window.addEventListener("blur", () => this.closeList());
    }
    set value(value) {
        if (value) {
            this._value = value;
            this._selectButtonLabel.textContent = this._getSelection(value).text;
        }
        else if (this._options.placeholder) {
            this._value = value;
            this._selectButtonLabel.textContent = this._options.placeholder;
        }
        else if (this._options.defaultValue) {
            this.value = this._options.defaultValue;
        }
        else {
            this.value = this.selections[0].value;
        }
        this._onDidChange.fire(this._value);
    }
    get value() {
        return this._value;
    }
    set disabled(disabled) {
        disabled
            ? this._element.classList.add("select-disabled")
            : this._element.classList.remove("select-disabled");
    }
    get disabled() {
        return this._options.disabled;
    }
    _getSelection(value) {
        for (const selection of this.selections) {
            if (selection.value === value)
                return selection;
        }
        throw new Error("Cannot find the selection \"" + value + "\".");
    }
    _hasSelectionValue(value) {
        for (const selection of this.selections) {
            if (selection.value === value)
                return true;
        }
        return false;
    }
    select(value) {
        if (value && !this._hasSelectionValue(value))
            throw new Error("Cannot select an inexisting selection \"" + value + "\".");
        this.value = value;
    }
    openList() {
        if (this._isOpened || this.disabled)
            return;
        this._isOpened = true;
        this._element.classList.add("opened");
        this._selectListElem.style.top = this._options.height + "px";
    }
    closeList() {
        if (!this._isOpened)
            return;
        this._isOpened = false;
        this._element.classList.remove("opened");
    }
    reset() {
        this.value = null;
    }
}
exports.Select = Select;
